import { createFileRoute, Outlet } from '@tanstack/react-router';

function IntegrationsLayout() {
  return (
    <div className="flex flex-col gap-4">
      <Outlet />
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/integrations')({
  component: IntegrationsLayout,
});
